import produce from 'immer';

import {
  ORDER_UPDATE,
  ORDER_DELETE,
  ORDER_CREATED,
  ADDRESSES_RECEIVED,
  SESSION_AUTH_INVALID,
  ADDRESSES_CLEAR,
  ADDRESS_LOOKUP_CLEAR,
  ORDER_CHECKOUT_RECEIVED,
  ADDRESS_SEARCH_RECEIVED,
  ADDRESSES_SET_PAGE,
  ADDRESSES_NEXT_PAGE,
  ORDER_ITEMS_RECEIVED
} from 'constants/actions';

export var INITIAL_STATE = {
  pending: {},
  items: [],
  checkout: null,
  addressesPage: 1,
  orderError: false
};

export const orders = produce((draft, action) => {
  switch (action.type) {
    case SESSION_AUTH_INVALID:
      draft = INITIAL_STATE;
      return draft;

    case ORDER_CHECKOUT_RECEIVED:
      draft.pending = { ...draft.pending, checkout: action.value };
      return draft;

    case ORDER_ITEMS_RECEIVED:
      draft.items = action.value;
      return draft;

    case ORDER_UPDATE:
      draft.pending = { ...draft.pending, ...action.value };
      return draft;

    case ORDER_DELETE:
      draft.pending = {};
      return draft;

    case ADDRESSES_RECEIVED:
      draft.pending = { ...draft.pending, ...action.value };
      return draft;

    case ADDRESS_LOOKUP_CLEAR:
      draft.pending.title_addresses = [];
      return draft;

    case ADDRESSES_NEXT_PAGE:
      draft.addressesPage = draft.addressesPage + 1;
      return draft;

    case ADDRESSES_SET_PAGE:
      draft.addressesPage = action.value;
      return draft;

    case ADDRESSES_CLEAR:
      draft.pending.council_addresses = [];
      draft.pending.council_addresses_query = '';
      draft.pending.council_addresses_updated = Date.now();

      return draft;

    case ADDRESS_SEARCH_RECEIVED:
      var addressState = draft.pending.address_state;

      if (addressState === 'WA') {
        draft.pending.title_addresses = action.value;
      } else {
        draft.pending.title_addresses = (draft.pending.title_addresses || []).concat(action.value).filter(filterDuplicateSA)
      }

      return draft;
    case ORDER_CREATED:
      draft.pending.id = action.value;
      draft.pending.complete = true;
      return draft;

    default:
      return draft;
  }
}, INITIAL_STATE);

export default orders;


function filterDuplicateSA (address, i, arr) {
  const vf  = address.volumeFolio;
  const key = `${vf.volFolPrefix}${vf.volume}-${vf.folio}`;

  var firstIndex = arr.findIndex(added => {
    const _vf = added.volumeFolio;
    const _key = `${_vf.volFolPrefix}${_vf.volume}-${_vf.folio}`

    return _key === key;
  });

  return firstIndex === i || firstIndex === -1;
}